import { render, staticRenderFns } from "./ToponymsList.vue?vue&type=template&id=ae08d452"
import script from "./ToponymsList.vue?vue&type=script&lang=js"
export * from "./ToponymsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports